import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  BadgeColors,
  BadgeComponent,
  DropdownComponent,
  DropdownItem,
  IconButtonComponent,
} from 'shared';
import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';

import { AuthService } from '../../../../auth/auth.service';
import { UserService } from '../../../../domain/user/user.service';

@Component({
  selector: 'app-user-menu',
  imports: [IconButtonComponent, TranslateModule, DropdownComponent, BadgeComponent],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  @ViewChild('userMenuTrigger', { static: true })
  userMenuTriggerRef!: ElementRef;

  private readonly translate = inject(TranslateService);
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);

  // Computed signals to avoid multiple signal reads in template
  currentUser = computed(() => this.userService.user());
  userFullName = computed(() => {
    const user = this.currentUser();
    return user ? `${user.firstName} ${user.lastName}` : '';
  });
  userEmail = computed(() => this.currentUser()?.email ?? '');
  userRole = computed(() => this.currentUser()?.role ?? '');

  // Role badge color mapping
  roleBadgeColor = computed(() => {
    const role = this.userRole().toLowerCase();
    switch (role) {
      case 'admin':
        return BadgeColors.red;
      case 'operator':
        return BadgeColors.blue;
      case 'viewer':
        return BadgeColors.grey;
      default:
        return BadgeColors.grey;
    }
  });

  menuItems: DropdownItem[] = [
    {
      value: 'logout',
      label: this.translate.instant('logout'),
      iconName: 'log-out',
    },
  ];

  onProfileOption(value: string) {
    if (value === 'logout') {
      this.authService.logout();
    }
  }
}
